module.exports = __webpack_public_path__ + "static/media/cardCollectionAgentBg.d2deb32d.png";